import { commonStyles, createStyles, StylesClasses } from '@utils/styles'

const styles = createStyles({
  cardWrapper: {
    padding: '1.25rem 1.25rem',
    borderRadius: '16px',
    border: '1px solid',
    borderColor: 'border.light',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    ...commonStyles.boxShadow,
  },
  needHelpSectionLink: {
    display: 'inline-block',
    textDecoration: 'underline',
    color: 'primary.main',
  },
})

export type StylesClassNames = StylesClasses<typeof styles>

export default styles
